import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import Header from "./Header";
import Hero from "./Hero";
import Footer from "./Footer";
import ExitIntentPopup from "./ExitIntentPopup";
import splitbee from "@splitbee/web";

// Supports weights 100-900
import "@fontsource-variable/inter";

import SvgSpriteDefs from "./SvgSpriteDefs";

splitbee.init({
  disableCookie: true,
  //token: "",
});

const Layout = ({ children, location = "", uptitle, title, slogan, cover }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      strapiGlobal {
        phone
        email
      }
    }
  `);

  const { phone, email } = data.strapiGlobal;

  return (
    <>
      <Header
        location={location}
        siteTitle={data.site.siteMetadata.title}
        uptitle={uptitle}
        title={title}
        slogan={slogan}
        cover={cover}
        phone={phone}
      />
      <main id="main">
        <Hero
          location={location}
          uptitle={uptitle}
          title={title}
          slogan={slogan}
          cover={cover}
        />
        {children}
      </main>
      <Footer location={location} title={title} phone={phone} email={email} />
      <ExitIntentPopup title={title} />
      {/* Form estático invisible para Netlify */}
      <form name="exit-intent" data-netlify="true" hidden>
        <input type="hidden" name="form-name" value="exit-intent" />
        <input type="text" name="contacto" />
        <input type="hidden" name="Página de salida" value={title} />
      </form>
      <SvgSpriteDefs />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
